export const analyses = [
  {
    id: 1,
    name: "загальний аналіз крові",
    needDirection: true,
    shortName: "ЗАК",
    forLor: true,
    forDent: true,
  },
  {
    id: 2,
    name: "загальний аналіз сечі",
    needDirection: true,
    shortName: "ЗАС",
    forLor: true,
    forDent: true,
  },
  {
    id: 3,
    name: "аналіз крові на групу та резус-фактор ",
    needDirection: true,
    shortName: "Група крові",
    forLor: true,
    forDent: true,
  },
  {
    id: 4,
    name: "глюкоза крові",
    needDirection: true,
    shortName: "Глюкоза",
    forDent: true,
    forLor: false,
  },
  {
    id: 5,
    name: "коагулограма",
    needDirection: true,
    shortName: "Коагулограма",
    forLor: true,
    forDent: true,
  },
  {
    id: 6,
    name: "ЕКГ",
    needDirection: false,
    shortName: "ЕКГ",
    forLor: true,
    forDent: true,
  },
  {
    id: 7,
    name: "Біохімічний аналіз крові (глюкоза, білок загальний, креатинін, сечовина, K, Na, Ca)",
    needDirection: true,
    shortName: "Біохімічний",
    forLor: true,
    forDent: false,
  },
  {
    id: 7,
    name: "Біохім. аналіз крові (креатинін, сечовина, K, Na, Ca)",
    needDirection: true,
    shortName: "Біохімічний",
    forDent: true,
    forLor: false,
  },
];

export const examinationTemplate = {
  name: "",
  needDirection: true,
  shortName: "",
};

const diagnosisMaxilloSurgeryList = [
  {
    id: "wrij3",
    name: "",
  },
  {
    id: "dwf",
    name: "Періодонтит",
  },
  {
    id: "rwenn3",
    name: "Абсцес шкіри",
  },
  { id: "e39f", name: "Гострий лімфаденіт" },
  {
    id: "w33;",
    name: "П-м нижньої щелепи",
  },

  {
    id: "fw33",
    name: "Перелом верхньої щелепи",
  },
  { id: "f233", name: "Атерома" },
  { id: "vs'22", name: "Епуліс" },
  {
    id: "ff2nns",
    name: "Радикулярна кіста",
  },
  {
    id: "333nf",
    name: "Фолікулярна кіста",
  },
  {
    id: "nchh4",
    name: "Ретенційна кіста",
  },
  {
    id: "fj33hhs",
    name: "Надкомплектні зуби",
  },
  {
    id: "3ss",
    name: "Ретеновані зуби",
  },
  {
    id: "33bbg",
    name: "Коротка вуздечка язика",
  },
  {
    id: "nae0",
    name: "Коротка вуздечка верхньої губи",
  },
  {
    id: "3h3na",
    name: "Новоутвір обличчя",
  },
  {
    id: "3fhna]",
    name: "Новоутвір ротової порожнини",
  },
  {
    id: "fnna000",
    name: "Серединна кіста шиї",
  },
  {
    id: "3h00an",
    name: "Множинний карієс",
  },
];
const diagnosisOtolaryngologyList = [
  { id: "3nh", name: "" },
  {
    id: "nhs0",
    name: "Закритий перелом кісток носа",
  },
  {
    id: "f4h",
    name: "Аденоїди III ступеню",
  },
  {
    id: "3l'h:",
    name: "Фурункул присінку носа",
  },
  {
    id: "33nhp[",
    name: "Хронічний декомпенс. тонзиліт",
  },
  {
    id: "nna0a",
    name: "Паратонзилярний абсцес",
  },
  {
    id: "jnha",
    name: "Викривлення переділки носа",
  },
  {
    id: "3jhha",
    name: "Гострий гнійний середній отит",
  },
  {
    id: "nna-",
    name: "Антрохоанальний поліп",
  },
  {
    id: "nag-",
    name: "Мастоїдит",
  },
  {
    id: "na11",
    name: "Новоутвір носа",
  },
  {
    id: "llam",
    name: "Новоутвір вуха",
  },
  {
    id: "223n",
    name: "Атрезія слухового ходу",
  },
  {
    id: "00aj",
    name: "Пансинусит",
  },
  {
    id: "32ha",
    name: "Хронічний середній отит",
  },
  {
    id: "55hha",
    name: "Сенсоневральна приглухуватість",
  },
  {
    id: "yuy",
    name: "Стороннє тіло носа",
  },
  {
    id: "bnag",
    name: "Стороннє тіло вуха",
  },
];

export const msDiagonosis = diagnosisMaxilloSurgeryList
  .map((item) => item.name)
  .sort(function (a, b) {
    return a.localeCompare(b);
  });

export const lorDiagonosis = diagnosisOtolaryngologyList
  .map((item) => item.name)
  .sort(function (a, b) {
    return a.localeCompare(b);
  });
export const townList = [
  {
    value: "",
    name: "оберіть місто",
    streets: [{ value: "", name: "оберіть вулицю" }],
  },
  {
    value: "Тернопіль",
    name: "Тернопіль",
    streets: [
      { name: "15 квітня" },
      { name: "Багата" },
      { name: "Балея" },
      { name: "Барвінських" },
      { name: "Безкоровайного" },
      { name: "Бенцаля" },
      { name: "Бережанська" },
      { name: "Березова" },
      { name: "Білецька" },
      { name: "Білогірська" },
      { name: "Блажкевич" },
      { name: "Богуна" },
      { name: "Бойківська" },
      { name: "Бойчуків" },
      { name: "Болюха" },
      { name: "Бордуляка" },
      { name: "Батьківського" },
      { name: "Броварна" },
      { name: "Бродівська" },
      { name: "Бриковича" },
      { name: "Брюкнера" },
      { name: "Будзиновського" },
      { name: "Будного" },
      { name: "Вагилевича" },
      { name: "Валова" },
      { name: "Вербицького" },
      { name: "Вербова" },
      { name: "Вертепна" },
      { name: "Весела" },
      { name: "Виговського" },
      { name: "Винниченка" },
      { name: "Вишнева" },
      { name: "Вишневецького" },
      { name: "Віконської" },
      { name: "Вільхова" },
      { name: "Вітовського" },
      { name: "Волинська" },
      { name: "Володимира Великого" },
      { name: "Вояків дивізії `Галичина`" },
      { name: "Гавдиди" },
      { name: "Гайова" },
      { name: "Гайова-бічна" },
      { name: "Галицька" },
      { name: "Галицького" },
      { name: "Героїв Крут" },
      { name: "Героїв Чорнобиля" },
      { name: "Гірняка" },
      { name: "Глибока" },
      { name: "Глибока Долина" },
      { name: "Глибочанська" },
      { name: "Глиняна" },
      { name: "Гнатюка" },
      { name: "Гніздовського" },
      { name: "Гоголя" },
      { name: "Головацького" },
      { name: "Голубовича" },
      { name: "Горбачевського" },
      { name: "Городна" },
      { name: "Грабовського" },
      { name: "Гребінки" },
      { name: "Громницького" },
      { name: "Грушевського" },
      { name: "Гузара" },
      { name: "Гуцульська" },
      { name: "Ґжицького" },
      { name: "Ґріґа" },
      { name: "Далека" },
      { name: "Деповського" },
      { name: "Дівоча" },
      { name: "Ділова" },
      { name: "Дністрянського" },
      { name: "Довбуша" },
      { name: "Довженка" },
      { name: "Доли" },
      { name: "Дорошенка" },
      { name: "Драгоманова" },
      { name: "Дружби" },
      { name: "Дубовецька" },
      { name: "Енергетична" },
      { name: "За Рудкою" },
      { name: "Загребельна" },
      { name: "Заміська" },
      { name: "Замкова" },
      { name: "Замонастирська" },
      { name: "Зарічна" },
      { name: "Захисників України" },
      { name: "Збаразька" },
      { name: "Зелена" },
      { name: "Злуки" },
      { name: "Золотогірська" },
      { name: "Іллєнка" },
      { name: "Калинова" },
      { name: "Камінна" },
      { name: "Канадська" },
      { name: "Кармелюка" },
      { name: "Карпенка" },
      { name: "Качали" },
      { name: "Квітки Цісик" },
      { name: "Квітова" },
      { name: "Київська" },
      { name: "Клима Савура" },
      { name: "Клінічна" },
      { name: "Козацька" },
      { name: "Коллонтая" },
      { name: "Коновальця" },
      { name: "Коперника" },
      { name: "Корольова" },
      { name: "Котляревського" },
      { name: "Коцюбинського" },
      { name: "Кривоноса" },
      { name: "Крушельницької" },
      { name: "Куліша" },
      { name: "Кульчинської" },
      { name: "Купчинського" },
      { name: "Куток" },
      { name: "Лемківська" },
      { name: "Леонтовича" },
      { name: "Лепкого" },
      { name: "Лесі Українки" },
      { name: "Леся Курбаса" },
      { name: "Липницького" },
      { name: "Липова" },
      { name: "Лисенка" },
      { name: "Листопадова" },
      { name: "Лісова" },
      { name: "Лозовецька" },
      { name: "Лукіяновича" },
      { name: "Лучаковського" },
      { name: "Львівська" },
      { name: "Мазепи" },
      { name: "Малишка" },
      { name: "Манастирського" },
      { name: "Марка Вовчка" },
      { name: "Медобірна" },
      { name: "Медова" },
      { name: "Межова" },
      { name: "Мєшковського" },
      { name: "Микулинецька" },
      { name: "Микулинецька-бічна" },
      { name: "Мирна" },
      { name: "Миру" },
      { name: "Михалевича" },
      { name: "Молодіжна" },
      { name: "Монюшка" },
      { name: "Морозенка" },
      { name: "Мостова" },
      { name: "Мостова-бічна" },
      { name: "Мстислава" },
      { name: "Набережна" },
      { name: "Над Ставом" },
      { name: "Над Яром" },
      { name: "Надзбручанська" },
      { name: "Наливайка" },
      { name: "Нечая" },
      { name: "Низинна" },
      { name: "Нова" },
      { name: "Новий Світ" },
      { name: "Новий Світ-бічна" },
      { name: "Новосонячна" },
      { name: "Об'їзна" },
      { name: "Оболоня" },
      { name: "Овочева" },
      { name: "Опільського" },
      { name: "Орлика" },
      { name: "Острозького" },
      { name: "Паращука" },
      { name: "Паркова" },
      { name: "Пелиха" },
      { name: "Перля" },
      { name: "Петлюри" },
      { name: "Петриківська" },
      { name: "Петрушевича" },
      { name: "Пирогова" },
      { name: "Південна" },
      { name: "Північна" },
      { name: "Підгірна" },
      { name: "Підгородня" },
      { name: "Підкови" },
      { name: "Піскова" },
      { name: "Подільська" },
      { name: "Покрови" },
      { name: "Поліська" },
      { name: "Польова" },
      { name: "Польового" },
      { name: "Приміська" },
      { name: "Проектна" },
      { name: "Промислова" },
      { name: "Просвіти" },
      { name: "Протасевича" },
      { name: "Пулюя" },
      { name: "Рєпіна" },
      { name: "Рівна" },
      { name: "Рудницького" },
      { name: "Руставелі" },
      { name: "Руська" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Самчука" },
      { name: "Сахарова" },
      { name: "Симоненка" },
      { name: "Сімовича" },
      { name: "Сірка" },
      { name: "Січинського" },
      { name: "Січових Стрільців" },
      { name: "Слівенська" },
      { name: "Сліпого" },
      { name: "Словацького" },
      { name: "Смакули" },
      { name: "Сонячна" },
      { name: "Спадиста" },
      { name: "Спортивна" },
      { name: "Стадникової" },
      { name: "Старий Поділ" },
      { name: "Старий Ринок" },
      { name: "Степана Бандери" },
      { name: "Степова" },
      { name: "Стефаника" },
      { name: "Стецька" },
      { name: "Стрімка" },
      { name: "Студинського" },
      { name: "Стуса" },
      { name: "Тарнавського" },
      { name: "Татарська" },
      { name: "Тбіліська" },
      { name: "Текстильна" },
      { name: "Теліги" },
      { name: "Тернопільська" },
      { name: "Тиха" },
      { name: "Тісна" },
      { name: "Торговиця" },
      { name: "Транспортна" },
      { name: "Тролейбусна" },
      { name: "Тютюнника" },
      { name: "Урожайна" },
      { name: "Фабрична" },
      { name: "Федьковича" },
      { name: "Фестивальна" },
      { name: "Франка" },
      { name: "Хліборобна" },
      { name: "Хмельницького" },
      { name: "Хутірська" },
      { name: "Циганська" },
      { name: "Чайковського" },
      { name: "Чарнецького" },
      { name: "Чернівецька" },
      { name: "Чорновола" },
      { name: "Чубинського" },
      { name: "Чумацька" },
      { name: "Шагайди" },
      { name: "Шашкевича" },
      { name: "Шевченка" },
      { name: "Шептицького" },
      { name: "Шкільна" },
      { name: "Шопена" },
      { name: "Шпитальна" },
      { name: "Шухевича" },
      { name: "Юності" },
      { name: "Юрчака" },
      { name: "Яблунева" },
      { name: "Яреми" },
      { name: "Яремчука" },
      { name: "Ярмуша" },
      { name: "Ясна" },
    ],
  },
  {
    value: "Бережани",
    name: "Бережани",
    streets: [
      { name: "1 травня" },
      { name: "8 березня" },
      { name: "Адамівська" },
      { name: "Бандери" },
      { name: "Банкова" },
      { name: "Богуна" },
      { name: "Бояна" },
      { name: "Браїлка" },
      { name: "Валова" },
      { name: "Ватутіна" },
      { name: "Верхня" },
      { name: "Вільховецька" },
      { name: "Вірменська" },
      { name: "Володимирська" },
      { name: "Гагаріна" },
      { name: "Гайова" },
      { name: "Галана" },
      { name: "Галицького" },
      { name: "Гімназійна" },
      { name: "Гоголя" },
      { name: "Грушевського" },
      { name: "Депутатська" },
      { name: "Джерельна" },
      { name: "Довженка" },
      { name: "Дружби" },
      { name: "Загороди" },
      { name: "Залісся" },
      { name: "Замкова" },
      { name: "Замость" },
      { name: "Зарайський потік" },
      { name: "Зарічна" },
      { name: "Захарка" },
      { name: "Західна" },
      { name: "Збічна" },
      { name: "Зелена" },
      { name: "Золочівська" },
      { name: "Зоряна" },
      { name: "Інститутська" },
      { name: "Івана Франка" },
      { name: "Кармелюка" },
      { name: "Кобилянської" },
      { name: "Ковпака" },
      { name: "Ковшевича" },
      { name: "Козацька" },
      { name: "Комарова" },
      { name: "Коперника" },
      { name: "Корольова" },
      { name: "Котляревського" },
      { name: "Коцюбинського" },
      { name: "Кривоноса" },
      { name: "Крута" },
      { name: "Крушельницької" },
      { name: "Кульчицької" },
      { name: "Кушніра" },
      { name: "Левицького" },
      { name: "Лепких" },
      { name: "Лесі Українки" },
      { name: "Лисенка" },
      { name: "Львівська" },
      { name: "Мазепи" },
      { name: "Маковея" },
      { name: "Медова" },
      { name: "Мечнікова" },
      { name: "Мирного" },
      { name: "Миру" },
      { name: "Міцкевича" },
      { name: "Молодіжна" },
      { name: "Монастирського" },
      { name: "Набережна" },
      { name: "Нахімова" },
      { name: "Незалежності" },
      { name: "Пирогова" },
      { name: "Підгірна" },
      { name: "Підкови" },
      { name: "Підлісна" },
      { name: "Площа Ринок" },
      { name: "Привокзальна" },
      { name: "Просвіти" },
      { name: "Пушкіна" },
      { name: "Репіна" },
      { name: "Рильського" },
      { name: "Ринок" },
      { name: "Рогатинська" },
      { name: "Родини Старухів" },
      { name: "Руриско" },
      { name: "Руська" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Старе Місто" },
      { name: "Степана Бандери" },
      { name: "Стефаника" },
      { name: "Твердохліба" },
      { name: "Тепла" },
      { name: "Тернопільська" },
      { name: "Тиха" },
      { name: "Тичини" },
      { name: "Топольна" },
      { name: "Хатки" },
      { name: "Хмельницького" },
      { name: "Цегельна" },
      { name: "Чайковського" },
      { name: "Червона" },
      { name: "Чорновола" },
      { name: "Шашкевича" },
      { name: "Шевченка" },
      { name: "Шептицького" },
    ],
  },
  {
    value: "Борщів",
    name: "Борщів",
    streets: [
      { name: "Бажана" },
      { name: "Базарна" },
      { name: "Богдана Хмельницького" },
      { name: "Богуна" },
      { name: "Борундяка" },
      { name: "Верхрадського" },
      { name: "Винниченка" },
      { name: "Відродження" },
      { name: "Вовківська" },
      { name: "Володимира Великого" },
      { name: "Володимира Івасюка" },
      { name: "Галицька" },
      { name: "Галичко" },
      { name: "Гетьмана Івана Мазепи" },
      { name: "Гніздовського" },
      { name: "Григорія Мазепи" },
      { name: "Грушевського" },
      { name: "Данила Галицького" },
      { name: "Довбуша" },
      { name: "Долина" },
      { name: "Дружня" },
      { name: "Заводська" },
      { name: "Замкова" },
      { name: "Зелена" },
      { name: "Івана Франка" },
      { name: "Йосипа Сліпого" },
      { name: "Кармелюка" },
      { name: "Катерини Попович" },
      { name: "Катюкова" },
      { name: "Козацька" },
      { name: "Колянківського" },
      { name: "Коновальця" },
      { name: "Котляревського" },
      { name: "Кошового" },
      { name: "Кривоноса" },
      { name: "Крушельницької" },
      { name: "Кут" },
      { name: "Левадна" },
      { name: "Лепкого" },
      { name: "Лесі Українки" },
      { name: "Леся Курбаса" },
      { name: "Лисенка" },
      { name: "Лісова" },
      { name: "Лозова" },
      { name: "Маковея" },
      { name: "Медова" },
      { name: "Нагірна" },
      { name: "Наливайка" },
      { name: "Незалежності" },
      { name: "Нічлава" },
      { name: "Нова" },
      { name: "Об'їздова" },
      { name: "Олімпійська" },
      { name: "Підвальна" },
      { name: "Підлісна" },
      { name: "Польова" },
      { name: "Пулюя" },
      { name: "Рубчакової" },
      { name: "Русенка" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Симона Петлюри" },
      { name: "Січових Стрільців" },
      { name: "Сковороди" },
      { name: "Староборщівська" },
      { name: "Степана Бандери" },
      { name: "Стуса" },
      { name: "Тичини" },
      { name: "Хмельницького" },
      { name: "Черемшини" },
      { name: "Чернецького" },
      { name: "Чорновола" },
      { name: "Чубинського" },
      { name: "Шафранюка" },
      { name: "Шевченка" },
      { name: "Шкільна" },
      { name: "Шухевича" },
      { name: "Ярослава Кондри" },
      { name: "Ярослава Мудрого" },
    ],
  },
  {
    value: "Бучач",
    name: "Бучач",
    streets: [
      { name: "1 грудня" },
      { name: "Агнона" },
      { name: "Бариська" },
      { name: "Баштова" },
      { name: "Бічна Бариська" },
      { name: "Бічна Богдана Хмельницького" },
      { name: "Бічна Вузька" },
      { name: "Бічна Замкова" },
      { name: "Бічна Лисенка" },
      { name: "Бічна Садова" },
      { name: "Бічна Цегельна" },
      { name: "Богдана Хмельницького" },
      { name: "Вербова" },
      { name: "Весела" },
      { name: "Винниченка" },
      { name: "Вишнева" },
      { name: "Водна" },
      { name: "Василя Стуса" },
      { name: "Вузька" },
      { name: "Галицька" },
      { name: "Гоголя" },
      { name: "Довбуша" },
      { name: "Дорошенка" },
      { name: "Заводська" },
      { name: "Залізнична" },
      { name: "Замкова" },
      { name: "Зелена" },
      { name: "Івана Франка" },
      { name: "Калинова" },
      { name: "Кам'яна" },
      { name: "Квітнева" },
      { name: "Кобилянської" },
      { name: "Ковпака" },
      { name: "Космонавтів" },
      { name: "Коцюбинського" },
      { name: "Коцюбинської" },
      { name: "Кринична" },
      { name: "Куліша" },
      { name: "Курбаса" },
      { name: "Лепкого" },
      { name: "Лесі Українки" },
      { name: "Лисенка" },
      { name: "Миру" },
      { name: "Міцкевича" },
      { name: "Млинарська" },
      { name: "Морозенка" },
      { name: "Мулярська" },
      { name: "Некрасова" },
      { name: "Підгаєцька" },
      { name: "Польова" },
      { name: "Просвіти" },
      { name: "Пушкіна" },
      { name: "Рильська" },
      { name: "Руська" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Степана Бандери" },
      { name: "Святого Миколая" },
      { name: "Середня" },
      { name: "Січових Стрільців" },
      { name: "Соломії Крушельницької" },
      { name: "Сонячна" },
      { name: "Сонячна бічна" },
      { name: "Сосюри" },
      { name: "Спадова" },
      { name: "Стефаника" },
      { name: "Стрипна" },
      { name: "Тичини" },
      { name: "Торгова" },
      { name: "Травнева" },
      { name: "Хвильового" },
      { name: "Цегельна" },
      { name: "Чайківського" },
      { name: "Шевченка" },
      { name: "Шкільна" },
      { name: "Шухевича" },
      { name: "Яворницького" },
    ],
  },
  {
    value: "Заліщики, ",
    name: "Заліщики",
    streets: [
      { name: "40 років Перемоги" },
      { name: "Богуна" },
      { name: "Богдана Хмельницького" },
      { name: "Весняна" },
      { name: "Володимира Великого" },
      { name: "Гайворонська" },
      { name: "Гайворонського" },
      { name: "Галана" },
      { name: "Гонти" },
      { name: "Гранична" },
      { name: "Грушевського" },
      { name: "Данила Галицького" },
      { name: "Дворище" },
      { name: "Джерельна" },
      { name: "Драгоманова" },
      { name: "Залізнична" },
      { name: "Заньковецької" },
      { name: "Зелена" },
      { name: "Зеленогайська" },
      { name: "Івана Франка" },
      { name: "Йосипа Сліпого" },
      { name: "Козацька" },
      { name: "Коновальця" },
      { name: "Кооперативна" },
      { name: "Котляревського" },
      { name: "Кропивницького" },
      { name: "Кустря" },
      { name: "Лепкого" },
      { name: "Лисенка" },
      { name: "Мазепи" },
      { name: "Маковея" },
      { name: "Марка Вовчка" },
      { name: "Миколаївка" },
      { name: "Миру" },
      { name: "Наддністрянська" },
      { name: "Надсекретна" },
      { name: "Наливайка" },
      { name: "Незалежності" },
      { name: "Нова" },
      { name: "Ольги Кобилянської" },
      { name: "Ольжича" },
      { name: "Подільська" },
      { name: "Полуботка" },
      { name: "Польова" },
      { name: "Поповича" },
      { name: "Рибацька" },
      { name: "Сагайдачного" },
      { name: "Симоненка" },
      { name: "Січових Стрільців" },
      { name: "Соломії Крушельницької" },
      { name: "Степана Бандери" },
      { name: "Стефаника" },
      { name: "Стуса" },
      { name: "Тирешкова" },
      { name: "Устименка" },
      { name: "Ущилівська" },
      { name: "Філатова" },
      { name: "Чорновола" },
      { name: "Чубинського" },
      { name: "Шашкевича" },
      { name: "Швайська" },
      { name: "Шевченка" },
      { name: "Шептицького" },
      { name: "Шкільна" },
      { name: "Шухевича" },
    ],
  },
  {
    value: "Збараж",
    name: "Збараж",
    streets: [
      { name: "22 січня" },
      { name: "50-річчя УПА" },
      { name: "780-річчя Збаража" },
      { name: "Айвазовська" },
      { name: "Базаринецька" },
      { name: "Барвінкова" },
      { name: "Богдана Хмельницького" },
      { name: "Богуславки" },
      { name: "Бульби" },
      { name: "Володимира Великого" },
      { name: "Винника" },
      { name: "Вишнева" },
      { name: "Вишнівецького" },
      { name: "Волинська" },
      { name: "Гайдамацька" },
      { name: "Гвардіціва" },
      { name: "Героїв Крут" },
      { name: "Гоголя" },
      { name: "Гонти" },
      { name: "Горбачевського" },
      { name: "Грушевського" },
      { name: "Данила Галицького" },
      { name: "Довга" },
      { name: "Дорошенка" },
      { name: "Дружби" },
      { name: "Енергетична" },
      { name: "Заводська" },
      { name: "Залізнична" },
      { name: "Замківського" },
      { name: "Заньковецької" },
      { name: "Зелена" },
      { name: "Злуки" },
      { name: "Івана Мазепи" },
      { name: "Івана Франка" },
      { name: "Івана Франка-бічна" },
      { name: "Кантемирівці" },
      { name: "Івана Франка" },
      { name: "Карпенка-Карого" },
      { name: "Клячківського" },
      { name: "Княгині Ольги" },
      { name: "Козубських" },
      { name: "Коперніка" },
      { name: "Корнійчука" },
      { name: "Корольова" },
      { name: "Космонавтів" },
      { name: "Костомарова" },
      { name: "Котляревського" },
      { name: "Коцюбинського" },
      { name: "Кривоноса" },
      { name: "Крип'якевича" },
      { name: "Крушельницької" },
      { name: "Куліша" },
      { name: "Курбаса" },
      { name: "Лесі Українки" },
      { name: "Лепкого" },
      { name: "Лисенка" },
      { name: "Ломоносова" },
      { name: "Лугова" },
      { name: "Львівська" },
      { name: "Майбороди" },
      { name: "Маковея" },
      { name: "Максимівське шосе" },
      { name: "Малюти" },
      { name: "Маневича" },
      { name: "Мирного" },
      { name: "Миру" },
      { name: "Мистецька" },
      { name: "Міцкевича" },
      { name: "Молодіжна" },
      { name: "Морозенка" },
      { name: "Набережна" },
      { name: "Наливайка" },
      { name: "Незалежності" },
      { name: "Нечая" },
      { name: "Низька" },
      { name: "Оболоня" },
      { name: "Ольги Кобилянської" },
      { name: "Осмолинка" },
      { name: "Острозького" },
      { name: "Павленка" },
      { name: "Паркова" },
      { name: "Петлюри" },
      { name: "Підгорева" },
      { name: "Подільська" },
      { name: "Полуботка" },
      { name: "Польова" },
      { name: "Поповича" },
      { name: "Прашка" },
      { name: "Просвіти" },
      { name: "Пушкіна" },
      { name: "Рильського" },
      { name: "Родини Білінських" },
      { name: "Руданського" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Садовського" },
      { name: "Самчука" },
      { name: "Степана Бандери" },
      { name: "Симеренка" },
      { name: "Симоненка" },
      { name: "Сірка" },
      { name: "Січових Стрільців" },
      { name: "Слов'янська" },
      { name: "Сонячна" },
      { name: "Сосюри" },
      { name: "Стефаника" },
      { name: "Стуса" },
      { name: "Технічна" },
      { name: "Тихого" },
      { name: "Тичини" },
      { name: "Тімірязєва" },
      { name: "Травнева" },
      { name: "Тургенєва" },
      { name: "Федьковича" },
      { name: "Харчука" },
      { name: "Хліборобів" },
      { name: "Чайковського" },
      { name: "Черняховського" },
      { name: "Чехова" },
      { name: "Чорновола" },
      { name: "Шевченка" },
      { name: "Шолом-Алейхема" },
      { name: "Шпитальна" },
      { name: "Яблунева" },
      { name: "Яворницького" },
      { name: "Ярослава Мудрого" },
      { name: "Ярославни" },
    ],
  },
  {
    value: "Зборів",
    name: "Зборів",
    streets: [
      { name: "8 березня" },
      { name: "Базарна" },
      { name: "Богдана Хмельницького" },
      { name: "Богуна" },
      { name: "Вербова" },
      { name: "Верхня" },
      { name: "Верхоставна" },
      { name: "Вишнева" },
      { name: "Галицька" },
      { name: "Гетьманська" },
      { name: "Гоголя" },
      { name: "Гончара" },
      { name: "Грушевського" },
      { name: "Данила Галицького" },
      { name: "Довженка" },
      { name: "Дружби" },
      { name: "Заводська" },
      { name: "Загребельна" },
      { name: "Заозерна" },
      { name: "Зарічна" },
      { name: "Івана Франка" },
      { name: "Івасюка" },
      { name: "Козацька" },
      { name: "Космонавтів" },
      { name: "Котляревського" },
      { name: "Коханівка" },
      { name: "Куклинці" },
      { name: "Купчинського" },
      { name: "Лесі Українки" },
      { name: "Ліпінського" },
      { name: "Львівська" },
      { name: "Медова" },
      { name: "Миру" },
      { name: "Млиновецька" },
      { name: "Набережна" },
      { name: "Надії" },
      { name: "Незалежності" },
      { name: "Паркова" },
      { name: "Перемоги" },
      { name: "Пушкіна" },
      { name: "Садова" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Стуса" },
      { name: "Тернопільська" },
      { name: "Травнева" },
      { name: "Чорновола" },
      { name: "Чумацька" },
      { name: "Шевченка" },
    ],
  },
  {
    value: "Копичинці",
    name: "Копичинці",
    streets: [
      { name: "22 січня" },
      { name: "Байди" },
      { name: "Богуна" },
      { name: "Богдана Хмельницького" },
      { name: "Весела" },
      { name: "Гусятинська" },
      { name: "Довга" },
      { name: "Дорошенка" },
      { name: "Ємелівка" },
      { name: "Заліщицька" },
      { name: "Зелена" },
      { name: "Івана Франка" },
      { name: "Котляревського" },
      { name: "Крута" },
      { name: "Курбаса" },
      { name: "Лепкого" },
      { name: "Лесі Українки" },
      { name: "Мазепи" },
      { name: "Молодіжна" },
      { name: "Паркова" },
      { name: "Польова" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Чайковського" },
      { name: "Чічки Андрієнка" },
      { name: "Чортківська" },
      { name: "Шашкевича" },
      { name: "Шевченка" },
      { name: "Шопена" },
    ],
  },
  {
    value: "Кременець",
    name: "Кременець",
    streets: [
      { name: "107 Кременецької дивізії" },
      { name: "Акімова" },
      { name: "Алея Підгірна" },
      { name: "Базарна" },
      { name: "Березина" },
      { name: "Березова" },
      { name: "Ватутіна" },
      { name: "Вербова" },
      { name: "Вериківського" },
      { name: "Вивозова" },
      { name: "Вишнівецька" },
      { name: "Відродження" },
      { name: "Виговського" },
      { name: "Вокзальна" },
      { name: "Гагаріна" },
      { name: "Гладка" },
      { name: "Глибока" },
      { name: "Глибокі Туники" },
      { name: "Глинянка" },
      { name: "Глінки" },
      { name: "Горбача" },
      { name: "Горького" },
      { name: "Грабівка" },
      { name: "Грушевського" },
      { name: "Джерельна" },
      { name: "Дівича" },
      { name: "Довга" },
      { name: "Драгоманова" },
      { name: "Дружби" },
      { name: "Дубенська" },
      { name: "Замкова" },
      { name: "Затишшя" },
      { name: "Зелена" },
      { name: "Івана Франка" },
      { name: "Климова" },
      { name: "Княжина" },
      { name: "Козацька" },
      { name: "Козубського" },
      { name: "Корнії" },
      { name: "Корольова" },
      { name: "Космонавтів" },
      { name: "Котляревського" },
      { name: "Красногірка" },
      { name: "Крейдяна" },
      { name: "Кривоноса" },
      { name: "Куличівка" },
      { name: "Курчатова" },
      { name: "Лесі Українки" },
      { name: "Липова" },
      { name: "Липовиця" },
      { name: "Ліцейна" },
      { name: "Льотчиків Визволителів" },
      { name: "Ляшуки" },
      { name: "Макова" },
      { name: "Марценівка" },
      { name: "Медова" },
      { name: "Мікрорайон" },
      { name: "Моргви" },
      { name: "Неприцького Грановського" },
      { name: "Нова" },
      { name: "Об'їздова" },
      { name: "Оксани Лятуринської" },
      { name: "Олега Кошового" },
      { name: "Олени Пчілки" },
      { name: "Олени Теліги" },
      { name: "Ольжича" },
      { name: "Осовиця" },
      { name: "Панаса Мирного" },
      { name: "Пасічна" },
      { name: "Переліски" },
      { name: "Першого Травня" },
      { name: "Піддівича" },
      { name: "Підлісна" },
      { name: "Піщана" },
      { name: "Платонової" },
      { name: "Плитниця" },
      { name: "Повздовжня" },
      { name: "Потік Ірва" },
      { name: "Пушкіна" },
      { name: "Садова" },
      { name: "Самчука" },
      { name: "Санаторійна" },
      { name: "Симона Петлюри" },
      { name: "Сичівка" },
      { name: "Сільська" },
      { name: "Спокійна" },
      { name: "Спортова" },
      { name: "Старі Вали" },
      { name: "Старого Детюка" },
      { name: "Стрілецька" },
      { name: "Текстильників" },
      { name: "Тиха" },
      { name: "Толстого" },
      { name: "Туницька" },
      { name: "Харчука" },
      { name: "Чорновола" },
      { name: "Шевченка" },
      { name: "Шкільна" },
      { name: "Шумська" },
      { name: "Ювілейна" },
      { name: "Юліуша Словацького" },
      { name: "Ясна" },
    ],
  },
  {
    value: "Ланівці",
    name: "Ланівці",
    streets: [
      { name: "Берегова" },
      { name: "Білозірська" },
      { name: "Богайчука" },
      { name: "Винниченка" },
      { name: "Вишнева" },
      { name: "Вишнівецька" },
      { name: "Відродження" },
      { name: "Волинська" },
      { name: "Гайова" },
      { name: "Грушевського" },
      { name: "Джерельна" },
      { name: "Драгоманова" },
      { name: "Дружби" },
      { name: "Дубина" },
      { name: "Енергетична" },
      { name: "Заводська" },
      { name: "Залізнична" },
      { name: "Запорізьких козаків" },
      { name: "Зарічна" },
      { name: "Західна" },
      { name: "Зелена" },
      { name: "Івана Франка" },
      { name: "Кармелюка" },
      { name: "Колгоспна" },
      { name: "Корольова" },
      { name: "Коротки" },
      { name: "Котляревського" },
      { name: "Лесі Українки" },
      { name: "Листопадова" },
      { name: "Лугова" },
      { name: "Миру" },
      { name: "Молодіжна" },
      { name: "Морозенка" },
      { name: "Набережна" },
      { name: "Незалежності" },
      { name: "Нова" },
      { name: "Новосілка" },
      { name: "Передова" },
      { name: "Північна" },
      { name: "Підгірна" },
      { name: "Польова" },
      { name: "Поповича" },
      { name: "Привокзальна" },
      { name: "Пушкіна" },
      { name: "Робітнича" },
      { name: "Ровенська" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Східна" },
      { name: "Тернопільська" },
      { name: "Травнева" },
      { name: "Українська" },
      { name: "Хлібна" },
      { name: "Хлібна-бічна" },
      { name: "Шевченка" },
      { name: "Ювілейна" },
    ],
  },
  {
    value: "Монастириська",
    name: "Монастириська",
    streets: [
      { name: "Богдана Хмельницького" },
      { name: "Відродження" },
      { name: "Володимира Великого" },
      { name: "Галицька" },
      { name: "Гнатюка" },
      { name: "Горішня" },
      { name: "Грушевського" },
      { name: "Добровідна" },
      { name: "Долішня" },
      { name: "Зелена" },
      { name: "Злуки" },
      { name: "Івана Франка" },
      { name: "Кисилевської" },
      { name: "Коновальця" },
      { name: "Краснікова" },
      { name: "Лесі Українки" },
      { name: "Мазепи" },
      { name: "Миру" },
      { name: "Нова" },
      { name: "Озерна" },
      { name: "Пекарська" },
      { name: "Перемоги" },
      { name: "Підгородня" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Січових Стрільців" },
      { name: "Степана Бандери" },
      { name: "Стецька" },
      { name: "Стуса" },
      { name: "Тиха" },
      { name: "Тичини" },
      { name: "Хвильового" },
      { name: "Чорновола" },
      { name: "Шевченка" },
      { name: "Шкільна" },
      { name: "Шухевича" },
    ],
  },
  {
    value: "Підгайці",
    name: "Підгайці",
    streets: [
      { name: "Бережанська" },
      { name: "Богдана Хмельницького" },
      { name: "Богуславки" },
      { name: "Боднарська" },
      { name: "Воїнів УПА" },
      { name: "Гунчака" },
      { name: "Дімітрова" },
      { name: "Замкова" },
      { name: "Злуки" },
      { name: "Івана Франка" },
      { name: "Коновальця" },
      { name: "Кравецька" },
      { name: "Лесі Українки" },
      { name: "Лисенка" },
      { name: "Мазепи" },
      { name: "Майдан Незалежності" },
      { name: "Марцелівка" },
      { name: "Мізерного Рена" },
      { name: "Мічуріна" },
      { name: "Молодіжна" },
      { name: "Поповича" },
      { name: "Рудницького" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Спасівська" },
      { name: "Спортивна" },
      { name: "Федьковича" },
      { name: "Чорновола" },
      { name: "Шевченка" },
      { name: "Шептицького" },
      { name: "Шкільна" },
      { name: "Юрдика-горішня" },
      { name: "Яворського" },
    ],
  },
  {
    value: "Почаїв",
    name: "Почаїв",
    streets: [
      { name: "Березина" },
      { name: "Богдана Хмельницького" },
      { name: "Бригадна" },
      { name: "Варшавська" },
      { name: "Верхня" },
      { name: "Винниченка" },
      { name: "Вишнева" },
      { name: "Воз'єднання" },
      { name: "Волинська" },
      { name: "Гагаріна" },
      { name: "Гайова" },
      { name: "Галицька" },
      { name: "Гоголя" },
      { name: "Граби" },
      { name: "Грушевського" },
      { name: "Дачна" },
      { name: "Дикунів" },
      { name: "Діброва" },
      { name: "Дорошенка" },
      { name: "Драли" },
      { name: "Дружби" },
      { name: "Жовтнева" },
      { name: "Жука" },
      { name: "Заводська" },
      { name: "Зайці" },
      { name: "Заньковецької" },
      { name: "Зелена" },
      { name: "Злуки" },
      { name: "Івана Франка" },
      { name: "Квіткова" },
      { name: "Кіндратюка" },
      { name: "Копані" },
      { name: "Космонавтів" },
      { name: "Котляревського" },
      { name: "Кременецька" },
      { name: "Крушельницької" },
      { name: "Лесі Українки" },
      { name: "Липова" },
      { name: "Лісова" },
      { name: "Лосятинська" },
      { name: "Лящука" },
      { name: "Макаренка" },
      { name: "Марка Вовчка" },
      { name: "Матросова" },
      { name: "Медова" },
      { name: "Миру" },
      { name: "Молодіжна" },
      { name: "Монастирська" },
      { name: "Наливайка" },
      { name: "Несова" },
      { name: "Нижня" },
      { name: "Нова" },
      { name: "Озерна" },
      { name: "Орловського" },
      { name: "Остапа Вишні" },
      { name: "Острозького" },
      { name: "Паркова" },
      { name: "Перемоги" },
      { name: "Південна" },
      { name: "Плетянка" },
      { name: "Польова" },
      { name: "Промислова" },
      { name: "Радивилівська" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Сонячна" },
      { name: "Спортивна" },
      { name: "Старотаражська" },
      { name: "Стельмащука" },
      { name: "Стефаника" },
      { name: "Суворова" },
      { name: "Теплична" },
      { name: "Тиха" },
      { name: "Толстого" },
      { name: "Ульріха" },
      { name: "Фабрична" },
      { name: "Церковна" },
      { name: "Чайковського" },
      { name: "Червоноармійська" },
      { name: "Шалівка" },
      { name: "Шатківського" },
      { name: "Шевченка" },
      { name: "Шкільна" },
      { name: "Юридична" },
      { name: "Ярослава Мудрого" },
      { name: "Ясна" },
    ],
  },
  {
    value: "Скалат",
    name: "Скалат",
    streets: [
      { name: "Богдана Хмельницького" },
      { name: "Богуна" },
      { name: "Винниченка" },
      { name: "Вишнівецька" },
      { name: "Вітер" },
      { name: "Грушевського" },
      { name: "Драгоманова" },
      { name: "Замкова" },
      { name: "Івана Франка" },
      { name: "Йосипа Сліпого" },
      { name: "Калнишевського" },
      { name: "Коновальця" },
      { name: "Кривоноса" },
      { name: "Лермонтова" },
      { name: "Лесі Українки" },
      { name: "Леся Курбаса" },
      { name: "Мазепи" },
      { name: "Малишка" },
      { name: "Наливайка" },
      { name: "Незалежності" },
      { name: "Полуботка" },
      { name: "Пулюя" },
      { name: "Сагайдачного" },
      { name: "Садовського" },
      { name: "Симона Петлюри" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Стадіонна" },
      { name: "Степана Бандери" },
      { name: "Стецька" },
      { name: "Стуса" },
      { name: "Тернопільська" },
      { name: "Чорновола" },
      { name: "Чубинського" },
      { name: "Шашкевича" },
      { name: "Шевченка" },
      { name: "Шептицького" },
      { name: "Шухевича" },
    ],
  },
  {
    value: "Теребовля",
    name: "Теребовля",
    streets: [
      { name: "22 січня" },
      { name: "Бічна" },
      { name: "Богдана Хмельницького" },
      { name: "Богуна" },
      { name: "Бойчука" },
      { name: "Будівельників" },
      { name: "Вавілова" },
      { name: "Вербова" },
      { name: "Вузька" },
      { name: "Галицька" },
      { name: "Гжицького" },
      { name: "Гірняка" },
      { name: "Глещавецька" },
      { name: "Грушевського" },
      { name: "Довбуша" },
      { name: "Довженка" },
      { name: "Дружби" },
      { name: "Зазамче" },
      { name: "Залізнична" },
      { name: "Зарчиного" },
      { name: "Застіноцька" },
      { name: "Зелена" },
      { name: "Зої Космодем'янської" },
      { name: "Івана Франка" },
      { name: "Кірова" },
      { name: "Князя Василька" },
      { name: "Кобилянської" },
      { name: "Ковпака" },
      { name: "Коротка" },
      { name: "Косака" },
      { name: "Котляревського" },
      { name: "Коцюбинського" },
      { name: "Кошового" },
      { name: "Крушельницької" },
      { name: "Лесі Українки" },
      { name: "Лисенка" },
      { name: "Ломоносова" },
      { name: "Лошнівська" },
      { name: "Мазепи" },
      { name: "Маковського" },
      { name: "Мандичевського" },
      { name: "Матросова" },
      { name: "Миколаєнка" },
      { name: "Миру" },
      { name: "Навроцького" },
      { name: "Нова" },
      { name: "Паращука" },
      { name: "Паркова" },
      { name: "Пилипа Орлика" },
      { name: "Південна" },
      { name: "Підзамче" },
      { name: "Підлісна" },
      { name: "Плебанівська" },
      { name: "Покрівка" },
      { name: "Польова" },
      { name: "Привокзальна" },
      { name: "Пушкіна" },
      { name: "Рильського" },
      { name: "Руднева" },
      { name: "Садики" },
      { name: "Садова" },
      { name: "Северина Наливайка" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Стрімка" },
      { name: "Стуса" },
      { name: "Тернопільська" },
      { name: "Тиха" },
      { name: "Федьковича" },
      { name: "Хоткевича" },
      { name: "Чайковського" },
      { name: "Чехова" },
      { name: "Шевченка" },
      { name: "Шишкіна" },
      { name: "Ювілейна" },
    ],
  },
  {
    value: "Хоростків",
    name: "Хоростків",
    streets: [
      { name: "Богдана Хмельницького" },
      { name: "Вибранівка" },
      { name: "Висока" },
      { name: "Вузька" },
      { name: "Гагаріна" },
      { name: "Галицька" },
      { name: "Голосна" },
      { name: "Грушевського" },
      { name: "Довга" },
      { name: "Дружби" },
      { name: "Зелена" },
      { name: "Івасюка" },
      { name: "Кармелюка" },
      { name: "Князя Володимира" },
      { name: "Комарова" },
      { name: "Коновальця" },
      { name: "Коцюбинського" },
      { name: "Лисенка" },
      { name: "Миру" },
      { name: "Наливайка" },
      { name: "Незалежності" },
      { name: "Низова" },
      { name: "Ольги Кобилянської" },
      { name: "Палія" },
      { name: "Січових Стрільців" },
      { name: "Сонячна" },
      { name: "Тиха" },
      { name: "Цукрова" },
      { name: "Чорновола" },
      { name: "Шевченка" },
      { name: "Шкільна" },
    ],
  },
  {
    value: "Чортків",
    name: "Чортків",
    streets: [
      { name: "16 липня" },
      { name: "16 липня бічна" },
      { name: "Антонича" },
      { name: "Аптечне" },
      { name: "Байди-Вишневецького" },
      { name: "Барвінського" },
      { name: "Бердо" },
      { name: "Березовського" },
      { name: "Білецька" },
      { name: "Богуна" },
      { name: "Броварова" },
      { name: "Бучацька" },
      { name: "Бучацька бічна" },
      { name: "Вербицького" },
      { name: "Вербова" },
      { name: "Весняна" },
      { name: "Вербова" },
      { name: "Весняна" },
      { name: "Вигнанська" },
      { name: "Виговського" },
      { name: "Вишнева" },
      { name: "Вільшана" },
      { name: "Вітовського" },
      { name: "Вітовського бічна" },
      { name: "Водна" },
      { name: "Вокзальна" },
      { name: "Гагаріна" },
      { name: "Галицька" },
      { name: "Гірська" },
      { name: "Глибока" },
      { name: "Глуха" },
      { name: "Гніздовського" },
      { name: "Гоголя" },
      { name: "Гончара" },
      { name: "Горбачевського" },
      { name: "Гранична" },
      { name: "Гранична бічна" },
      { name: "Гранична Нова" },
      { name: "Грушевського" },
      { name: "Джерельна" },
      { name: "Довбуша" },
      { name: "Дорошенка" },
      { name: "Драгоманова" },
      { name: "Заводська" },
      { name: "Залізнична" },
      { name: "Замкова" },
      { name: "Зелена" },
      { name: "Золотарка" },
      { name: "Івасюка" },
      { name: "Каденюка" },
      { name: "Карабіневича" },
      { name: "Кармелюка" },
      { name: "Київська" },
      { name: "Князя Володимира Великого" },
      { name: "Кобилянської" },
      { name: "Коновальця" },
      { name: "Копичинецька" },
      { name: "Копичинецька бічна" },
      { name: "Корольова" },
      { name: "Коротка" },
      { name: "Котляревського" },
      { name: "Коцюбинського" },
      { name: "Кривоноса" },
      { name: "Криницького" },
      { name: "Крушельницької" },
      { name: "Левицького" },
      { name: "Лемківська" },
      { name: "Леонтовича" },
      { name: "Лепких" },
      { name: "Лепкого" },
      { name: "Лисенка" },
      { name: "Лісова" },
      { name: "Мазепи" },
      { name: "Маковея" },
      { name: "Маньовського" },
      { name: "Мельника" },
      { name: "Мельничука" },
      { name: "Мистецька" },
      { name: "Млинарська" },
      { name: "Молодіжна" },
      { name: "Монастирська" },
      { name: "Монастирська бічна" },
      { name: "Надбережна" },
      { name: "Надрічна" },
      { name: "Наливайка" },
      { name: "Незалежності" },
      { name: "Нова" },
      { name: "Носса" },
      { name: "Об'їзна" },
      { name: "Об'їзна бічна" },
      { name: "Огієнка" },
      { name: "Ольжича" },
      { name: "Орлика" },
      { name: "Паркова" },
      { name: "Петрушевича" },
      { name: "Пігута" },
      { name: "Підгірна" },
      { name: "Підгірна Нова" },
      { name: "Підлісна" },
      { name: "Пітушевського" },
      { name: "Подільська" },
      { name: "Полуботка" },
      { name: "Польова" },
      { name: "Проїзна" },
      { name: "Пулюя" },
      { name: "Рильського" },
      { name: "Ринок" },
      { name: "Росляка" },
      { name: "Рубчакової" },
      { name: "Рудькова" },
      { name: "Савки" },
      { name: "Сагайдачного" },
      { name: "Садова" },
      { name: "Середня" },
      { name: "Сингаївського" },
      { name: "Синенького" },
      { name: "Сірка" },
      { name: "Січинського" },
      { name: "Січових Стрільців" },
      { name: "Сковороди" },
      { name: "Сліпого" },
      { name: "Сонячна" },
      { name: "Сонячна Верхня" },
      { name: "Стефаника" },
      { name: "Стрімка" },
      { name: "Стуса" },
      { name: "Тарнавського" },
      { name: "Теліги" },
      { name: "Теребовлянська" },
      { name: "Тудора" },
      { name: "Удовиченка" },
      { name: "Українки" },
      { name: "Франка" },
      { name: "Хичія" },
      { name: "Хмельницького" },
      { name: "Церковна" },
      { name: "Чайковського" },
      { name: "Червоний Берег" },
      { name: "Чортківська" },
      { name: "Чубинського" },
      { name: "Шашкевича" },
      { name: "Шеремети" },
      { name: "Шкільна" },
      { name: "Шопена" },
      { name: "Шопена бічна" },
      { name: "Шухевича" },
      { name: "Юрчинських" },
      { name: "Ягільницька" },
      { name: "Яремчука" },
      { name: "Ясна" },
    ],
  },
  {
    value: "Шумськ",
    name: "Шумськ",
    streets: [
      { name: "840-річчя Шумська" },
      { name: "Будівельників" },
      { name: "Богдана Хмельницького" },
      { name: "Вишневий" },
      { name: "Вишнева" },
      { name: "Вілійська" },
      { name: "Волинська" },
      { name: "Гагаріна" },
      { name: "Добровінського" },
      { name: "Дружби" },
      { name: "Данилевича" },
      { name: "Енергетична" },
      { name: "Жовтнева" },
      { name: "Заводська" },
      { name: "Зелена" },
      { name: "Івана Франка" },
      { name: "Котляревського" },
      { name: "Князя Острозького" },
      { name: "Лесі Українки" },
      { name: "Миру" },
      { name: "Незалежності" },
      { name: "Народицька" },
      { name: "Набережна" },
      { name: "Озерна" },
      { name: "Промислова" },
      { name: "Підгірна" },
      { name: "Садова" },
      { name: "Сонячна" },
      { name: "Стадіонна" },
      { name: "Свободи" },
      { name: "Українська" },
      { name: "Уласа Самчука" },
      { name: "Чирянська" },
      { name: "Шевченка" },
      { name: "Ювілейна" },
    ],
  },
];

// { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
//       { name: "" },
export const districtList = [
  { value: "", name: "оберіть район" },
  { value: "Тернопільський район", name: "Тернопільський" },
  { value: "Кременецький район", name: "Кременецький" },
  { value: "Чортківський район", name: "Чортківський" },
];
export const letters = [
  { name: "Літера...", value: "" },
  { name: "А", value: "А" },
  { name: "Б", value: "Б" },
  { name: "В", value: "В" },
  { name: "Г", value: "Г" },
  { name: "Д", value: "Д" },
  { name: "Е", value: "Е" },
  { name: "Є", value: "Є" },
  { name: "Ж", value: "Ж" },
  { name: "З", value: "З" },
];
